import { Input, Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'tr-spinner',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    template: `<span *ngIf="visible" class='tr-spinner'>
                    <svg [ngClass]="[ 'circular--' + size]" class="circular" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                    </svg>
              </span>`,
    styleUrls: ['./tr-spinner.component.scss'],
})
export class TrSpinner {

    @Input() public size: 'default' | 'big'  | 'medium' = 'default';
    @Input() public visible: boolean = true;

}
